import { StockSkuResource } from "../api/barcodeSystem/stockSkus/get";
import { CreateStockSkuRequest, UpdateStockSkuRequest } from "../api/barcodeSystem/stockSkus/create";

export class EditStockSkuModel {
    isNew: boolean;
    id: number;
    companyId: number = null;
    manufacturerCode: string = null;
    sku: string;
    commodity: string;
    itemDescription: string;
    isBulkItem: boolean = false;
    bulkScanCode: string;
    isActive: boolean = true;
    visible: boolean = false;
    loading: boolean = true;
    saving: boolean = false;

    showForNewStockSku() {
        this.isNew = true;
        this.loading = false;
    }

    showForExistingStockSku(stockSku: StockSkuResource) {
        this.isNew = false;
        this.loading = false;
        this.id = stockSku.id;
        this.companyId = stockSku.companyId;
        this.manufacturerCode = stockSku.manufacturerCode;
        this.sku = stockSku.sku;
        this.commodity = stockSku.commodity || stockSku.itemType;
        this.itemDescription = stockSku.itemDescription;
        this.isBulkItem = stockSku.isBulkItem;
        this.bulkScanCode = stockSku.bulkScanCode;
        this.isActive = stockSku.isActive;
    }

    toCreateStockSkuRequest(): CreateStockSkuRequest {
        return {
            companyId: this.companyId,
            manufacturerCode: this.manufacturerCode,
            sku: this.sku,
            commodity: this.commodity,
            itemType: this.commodity,
            itemDescription: this.itemDescription,
            isBulkItem: this.isBulkItem,
            bulkScanCode: this.isBulkItem ? this.bulkScanCode : null,
            isActive: this.isActive
        };
    }

    toUpdateStockSkuRequest(): UpdateStockSkuRequest {
        return {
            id: this.id,
            companyId: this.companyId,
            manufacturerCode: this.manufacturerCode,
            sku: this.sku,
            commodity: this.commodity,
            itemType: this.commodity,
            itemDescription: this.itemDescription,
            isBulkItem: this.isBulkItem,
            bulkScanCode: this.isBulkItem ? this.bulkScanCode : null,
            isActive: this.isActive
        };
    }
}
